/** React */
import { useTranslation } from "react-i18next";

/** Images */
import xImage from "../../assets/x.svg"

/** MUI icons */
import FilterAltIcon from "@mui/icons-material/FilterAlt";

/** MUI */
import {
    Avatar,
    Badge,
    Button,
    Grid,
    Link,
    Popover,
    Stack,
    Typography,
} from "@mui/material";

/** Components */
import BaseButton from "./BaseButton";

const FiltersPopover = (props) => {
    const { children, id, open, anchorEl, handleClose, cleanFilters, handleClick, length, addFilter, disabled, disabledButton = false } = props;
    const [t] = useTranslation("global");

    return (
        <>
            <Badge
                badgeContent={<Avatar alt="x" src={xImage} sx={{ width: "17px", height: "17px" }} />}
                invisible={length > 0 ? false : true}
                color="primary"
                sx={{
                    cursor: disabledButton ? "auto" : "pointer",
                    fontSize: "inherit",
                    width: { xs: "100%", md: "160px" },
                    "& .MuiBadge-badge": {
                        height: "17px !important",
                        minWidth: "17px !important",
                        padding: "0px !important",
                        zIndex: 0
                    }
                }}
                onClick={cleanFilters}
            >
                <BaseButton
                    fullWidth
                    disableElevation
                    onClick={handleClick}
                    variantType="filtersButton"
                    disabled={disabledButton ?? false}
                >
                    {<Stack direction="row" alignItems="start" display="flex" spacing={1}>
                        <FilterAltIcon sx={{ width: "17px", height: "17px" }} />
                        <Typography fontWeight={600} sx={{ lineHeight: "normal" }}>{t("dashboard.filters")}</Typography>
                        {length > 0 ? (
                            <Avatar
                                id="filterButton"
                                sx={{
                                    backgroundColor: "#361A52",
                                    color: "#FFF",
                                    fontSize: "9px",
                                    height: "17px",
                                    ml: "20px",
                                    transition: "0.3s",
                                    width: "17px",
                                }}
                            >
                                {length}
                            </Avatar>
                        ) : (
                            ""
                        )}
                    </Stack>}
                </BaseButton>
            </Badge>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '6px',
                            boxShadow: '4px 4px 10px 5px rgba(33, 0, 63, 0.1)',
                            p: '24px 32px',
                            width: "40%",
                        }
                    }
                }}
            >
                <Typography variant="h3" pb={2}>
                    {t("dashboard.searchFilters")}
                </Typography>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12}>
                        {children}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Link
                        component={Button}
                        onClick={addFilter}
                        sx={{ fontSize: 14, fontWeight: 600, textDecoration: "none" }}
                        disabled={disabled}
                    >
                        + {t("filters.addFilter")}
                    </Link>
                </Grid>
            </Popover>
        </>
    );
};

export default FiltersPopover;
